import { Stack } from '@/ux-common/components/stack/stack';
import { Typography } from '@/ux-common/components/typography/typography';

export const EmptyDeviceAttributeList = () => (
  <Stack className="text-center py-2">
    <Typography as="p" className="text-body-base text-ckds-text-fg-tier3">
      No trend points available for this device
    </Typography>
  </Stack>
);
